
import BaseSection from "@/components/base/BaseSection.vue";
import { Insurance } from "@/models/www/Insurance";
import { useBookingStore } from "@/store/booking";
import useVuelidate from "@vuelidate/core";
import { computed, defineComponent, PropType } from "vue";
import InsuranceExtend from "./InsuranceExtend.vue";
import InsuranceRegular from "./InsuranceRegular.vue";

export default defineComponent({
	components: {
		BaseSection,
		InsuranceExtend,
		InsuranceRegular
	},
	props: {
		insurances: {
			type: Array as PropType<Insurance[]>,
		},
	},
	setup() {
		const v$ = useVuelidate();
		const bookingStore = useBookingStore();

		const isAmendmentMode = computed(() => bookingStore.getBooking.amendmentMode);

		return { v$, isAmendmentMode }
	}
});
